import axios from 'axios'

export function readFile (fileRequest: Object) {
  return axios.post(`/read-file`, fileRequest,{
    responseType: "blob"
  })
}
